<template>
	<div class="quiero-mi-evento">
		<div class="container">
			<kinesis-container style="width: 100%">
				<kinesis-element :strength="10" type="depth" class="kinesis-element">
					<div class="quiero-mi-evento-content">
						<h1>Quiero publicar mi evento</h1>
						<p>Publicá tu evento en cuestión de minutos y comenzá a vender entradas hoy mismo</p>
						<button @click.prevent="redirectToContact()">¡Empezar ahora!</button>
					</div>
				</kinesis-element>
			</kinesis-container>
		</div>
	</div>
</template>

<script>
	import {KinesisContainer, KinesisElement} from "vue-kinesis";

	export default {
		components: {
			KinesisContainer,
			KinesisElement,
		},
		methods: {
			redirectToContact(){
				this.$router.push({ name: 'contacto' })
			}
		}
	};
</script>

<style lang="scss" scoped>
	.quiero-mi-evento {
		width: 100%;
		background-color: var(--color-white);
		padding: 40px;
		@include flex(column, center, center);

		.container {
			@include flex(column, center, center);

			.quiero-mi-evento-content {
				width: 100%;
				border-radius: 22px;
				color: var(--color-white);
				padding: 40px;
				// background-image: url("../assets/quieropublicar.jpg");
				background-color: var(--color-secondary);
				background-size: cover;
				background-position: center;
				min-height: 380px;
				@include flex(column, center, center);
				overflow: hidden;
				position: relative;

				// &:after{
				// 	content: '';
				// 	position: absolute;
				// 	width: 100%;
				// 	height: 100%;
				// 	top: 0px;
				// 	left: 0px;

				// }

				h1 {
					font-size: 38px;
					font-weight: var(--fw-700);
					font-family: var(--font-sora);
					width: 44%;
					text-align: center;
				}

				p {
					margin: 20px 0px;
					font-size: 17px;
					width: 34%;
					text-align: center;
					line-height: 1.6em;
				}

				button {
					@include flex(row, center, center);
					text-decoration: none;
					padding: 0px 30px;
					margin-right: 10px;
					font-size: 11px;
					font-family: var(--font-sora);
					font-weight: var(--fw-700);
					line-height: 1.3em;
					letter-spacing: 0.8px;
					text-transform: uppercase;
					color: var(--color-darker);
					border-radius: 99px;
					margin-left: 14px;
					height: 48px;
					border: 1px solid var(--color-primary);
					background-color: var(--color-primary);
					cursor: pointer;
					@include transition(all 0.2s);

					&:hover {
						border: 1px solid var(--color-primary);
						background-color: var(--color-primary);
						color: var(--color-darker);
					}
				}
			}
		}
	}

	@media screen and (max-width: 900px){
		.quiero-mi-evento {
			display: none;
		}
	}
</style>
